module.exports = __webpack_public_path__ + "static/media/tq.c2de5e75.jpg";